const initialState = {
  fundDetails: [],
  fundsViewV2: [],
  payoutTransactions: [],
  calculatedfunds: {}, // Added for global funds calculations
  error: null // Add error state
};

// Define mapping from object keys to display labels (shared by both functions)
const keyToLabelMap = {
  'available_margin': 'Available Margin',
  'opening_balance': 'Balance',
  'margin_used': 'Blocked Margin',
  'client_id': 'Client ID',
  "net_balance_for_mtm":"Equity"
  // 'equity_credit_sell': 'Equity',
  // Add more mappings as needed
};

// Helper function to convert object to array of arrays format
const objectToArrayOfArrays = (obj) => {
  // Define the order of fields to display
  const displayOrder = [
    'Balance',
    'Available Margin',
    'Pnl',
    'Blocked Margin',
    'Equity'
  ];
  
  // Create arrays for known fields
  const result = [];
  
  // Process each key in the object
  Object.entries(obj).forEach(([key, value]) => {
    let displayLabel;
    let displayValue = value;
    
    // Map specific keys to display labels
    switch (key) {
      case 'available_margin':
        displayLabel = 'Available Margin';
        // Preserve negative values for available margin
        displayValue = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'margin_used':
        displayLabel = 'Blocked Margin';
        displayValue = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'opening_balance':
        displayLabel = 'Balance';
        displayValue = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'net_balance_for_mtm':
        displayLabel = 'Equity';
        displayValue = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      default:
        // For other keys, use the shared mapping or convert snake_case to Title Case
        displayLabel = keyToLabelMap[key] || key.split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        // Convert numeric string values to numbers with 2 decimal places
        if (typeof value === 'string' && !isNaN(Number(value))) {
          displayValue = Number(value).toFixed(2);
        }
    }
    
    result.push([displayLabel, displayValue]);
  });
  
  // Sort according to display order
  result.sort((a, b) => {
    const indexA = displayOrder.indexOf(a[0]);
    const indexB = displayOrder.indexOf(b[0]);
    
    // If both items are in the order list, sort by their order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // If only one is in the order list, it comes first
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // If neither is in the order list, sort alphabetically
    return a[0].localeCompare(b[0]);
  });
  
  return result;
};

// Helper function to update existing array of arrays with new object data
const updateArrayWithObjectData = (existingArray, newObj) => {
  if (!Array.isArray(existingArray) || existingArray.length === 0) {
    return objectToArrayOfArrays(newObj);
  }
  
  // Create a copy of the existing array
  const updatedArray = [...existingArray];
  
  // Update values where keys match
  Object.entries(newObj).forEach(([key, value]) => {
    // Convert object key to display label
    let displayLabel;
    
    // Map specific keys to display labels
    switch (key) {
      case 'available_margin':
        displayLabel = 'Available Margin';
        // Preserve negative values
        value = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'margin_used':
        displayLabel = 'Blocked Margin';
        value = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'opening_balance':
        displayLabel = 'Balance';
        value = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      case 'net_balance_for_mtm':
        displayLabel = 'Equity';
        value = typeof value === 'string' ? Number(value).toFixed(2) : Number(value).toFixed(2);
        break;
      // Add more mappings as needed
      default:
        // Use the key mapping from objectToArrayOfArrays function
        displayLabel = keyToLabelMap[key] || key.split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        // Convert numeric string values to numbers with 2 decimal places
        if (typeof value === 'string' && !isNaN(Number(value))) {
          value = Number(value).toFixed(2);
        }
    }
    
    // Find the corresponding item in the array
    const index = updatedArray.findIndex(item => 
      Array.isArray(item) && item[0] === displayLabel);
    
    // If found, update the value
    if (index !== -1) {
      updatedArray[index][1] = value;
    }
    // Could add "else" to add new items if needed
  });
  
  return updatedArray;
};

const funds = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FUNDS":
      return {
        ...state,
        fundDetails: action.payload,
        error: null // Clear any previous errors
      };
    case "SET_FUNDS_VIEW_V2":
      return {
        ...state,
        fundsViewV2: action.payload,
        error: null // Clear any previous errors
      };
    case "SET_PAYOUT_TRANSACTIONS":
      return {
        ...state,
        payoutTransactions: action.payload,
      };
    case "SET_CALCULATED_FUNDS":
      return {
        ...state,
        calculatedfunds: action.payload,
      };
    case "SET_FUNDS_ERROR":
      return {
        ...state,
        error: action.payload
      };
    case "UPDATE_FUNDS_DATA_FROM_WS":
      // Handle WebSocket updates to funds data
      // Make sure we don't overwrite the entire fundsViewV2 array  
      // If fundsViewV2 is an array, update it properly
      if (Array.isArray(state.fundsViewV2)) {
        return {
          ...state,
          fundsViewV2: [action.payload],
          error: null // Clear any previous errors
        };
      } else {
        // If it's an object, merge the new data
        return {
          ...state,
          fundsViewV2: action.payload,
          error: null // Clear any previous errors
        };
      }
    default:
      return state;
  }
};

export default funds;
